import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseOrdergifts } from "./UseOrdergifts";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import SearchComOff from "../../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ProductsCondition(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { AddCondition, RemoveCondition } = UseOrdergifts();
  const [products, setProducts] = useState([]);
  const [pageState, setPageState] = useState({
    page: 1,
  });

  const [name, setName] = useState("");
  const [addProduct, setAddProduct] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    giftID: undefined,
    type: undefined,
    value: undefined,
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    giftID: undefined,
    type: undefined,
    value: undefined,
  });

  useEffect(() => {
    // if (props.giftID) {
    setStateAdd({
      giftID: props.giftID,
      type: 4,
      value: undefined,
    });
    // }
  }, [props.giftID, props.showProducts]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "productID",
      width: 90,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productName",
      width: 350,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                giftID: props.giftID,
                type: 4,
                value: cellValues.row.productID,
                name: cellValues.row.productName,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addProduct",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddProduct(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  const handleChange = (panel) => (event, isExpanded) => {
    if (props.giftID) {
      props.setExpanded(isExpanded ? panel : false);
      if (isExpanded) {
        const element = document.getElementById("panel4");
        setTimeout(() => {
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      enqueueSnackbar("ابتدا اطلاعات فوق را ثبت کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return;
    }
  };

  return (
    <Accordion
      id="panel4"
      expanded={props.expanded === "panel4"}
      onChange={handleChange("panel4")}
      style={{ marginTop: "20px", paddingTop: "5px", paddingBottom: "5px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel4bh-content"
        id="panel4bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            لیست محصول ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          <Dialog
            sx={{ zIndex: 200 }}
            fullWidth
            maxWidth="sm"
            open={addProduct}
            onClose={() => setAddProduct(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              sx={{ p: 1, px: 2 }}
              color="secondary"
              id="alert-dialog-title"
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle2">
                  محصول را انتخاب کنید
                </Typography>

                <IconButton
                  onClick={() => {
                    setStateAdd({ ...stateAdd, value: undefined });
                    setAddProduct(false);
                  }}
                >
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 1,
                }}
              >
                <SearchComOff
                  orderGift
                  productID={stateAdd.value}
                  productModel={stateAdd}
                  setProductModel={setStateAdd}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 3,
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{ mr: 2 }}
                    onClick={() => {
                      if (!stateAdd.value) {
                        enqueueSnackbar("محصول را انتخاب کنید", {
                          variant: "error",
                          autoHideDuration: 2000,
                          preventDuplicate: true,
                        });
                        return;
                      }
                      // return;
                      setProgress(true);
                      AddCondition(stateAdd, () => {
                        props.callback(props.giftID);
                        setAddProduct(false);
                        setStateAdd({ ...stateAdd, value: undefined });
                      });
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        if (!stateAdd.value) {
                          enqueueSnackbar("محصول را انتخاب کنید", {
                            variant: "error",
                            autoHideDuration: 2000,
                            preventDuplicate: true,
                          });
                          return;
                        }
                        AddCondition(stateAdd, () => {
                          setProgress(true);
                          setStateAdd({ ...stateAdd, value: undefined });
                          props.callback(props.giftID);
                          setAddProduct(false);
                        });
                      }
                    }}
                  >
                    ثبت
                  </Button>
                  <Button
                    onClick={() => setAddProduct(false)}
                    color="secondary"
                    variant="outlined"
                  >
                    انصراف
                  </Button>
                </Box>
              </Box>
            </DialogContent>
          </Dialog>
          {props.state.products ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              rows={props.state.products ? props.state.products : []}
              page={pageState.page - 1}
              pageSize={20}
              Pagination
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...pageState, page: newPage + 1 }));
              }}
              rowCount={
                props.state.products && props.state.products.length
                  ? props.state.products.length
                  : 1
              }
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  nofab: true,
                  noPageCount: true,
                  isLtr: true,

                  rowCount:
                    props.state.products && props.state.products.length
                      ? props.state.products.length
                      : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "id",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
          <DeleteRow
            deleteState={deleteState}
            setDeleteState={setDeleteState}
            type={"محصول"}
            callback={() => {
              let sendModel = {
                type: 4,
                giftID: deleteState.giftID,
                value: deleteState.value,
              };
              setProgress(true);
              RemoveCondition(sendModel, () => {
                props.callback(deleteState.giftID);
              });
            }}
          ></DeleteRow>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
